import React from "react";
import { Camera } from "lucide-react";

const EVIDENCE_SERVICE_TYPES = ["grave_care", "secret_shopper"];

// Совпадает с бэкендом _evidence_mode: флаг ИЛИ доказательный тип; B2B — всегда водяной знак
export const isEvidenceMode = (task) =>
  !!task && !task.is_b2b && task.payment_mode !== "direct" &&
  (!!task.evidence_photo_report || EVIDENCE_SERVICE_TYPES.includes(task.service_type));

// T4-3: исполнитель заранее видит, что его фотоотчёт откроется заказчику без водяного знака
export const EvidenceBadge = ({ task, testId = "evidence-mode-badge", className = "" }) => {
  if (!isEvidenceMode(task)) return null;
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium ${className}`}
      style={{ background: "#FEF3C7", color: "#92400E", border: "1px solid #FCD34D" }}
      title="Фото, видео и аудио вашего отчёта заказчик увидит без водяного знака ещё до подтверждения задания">
      <Camera size={12} /> Фотоотчёт виден заказчику сразу в полном качестве
    </span>
  );
};
